import styled from 'styled-components';
import { Text as T } from 'grommet';
import React from 'react';

// Create a wrapper to break circular reference
const TextBase = React.forwardRef<any, any>((props, ref) => (
  <T {...props} ref={ref} />
));

export const Text = styled(TextBase)<{
  center?: boolean;
  color?: string;
  weight?: number;
}>`
  font-family: 'Maison Neue', system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Helvetica, Arial, sans-serif;
  font-size: ${(p: any) => (p.size ? '' : '18px')}; // default to grommet
  line-height: ${(p: any) => (p.size ? '' : '24px')}; // default to grommet
  font-style: normal;
  font-weight: ${(p: any) =>
    p.weight ? undefined : 300}; // default to grommet
  letter-spacing: normal;
  color: ${(p: any) => (p.color ? p.color : p.theme.gray.lightest)};
  margin: 0;
  display: block;
  text-align: ${(p: { center?: boolean }) => p.center && 'center'};
`;
